import { forwardRef } from "react"
import { deepmerge } from "@mui/utils"
import { Link as BaseLink } from "react-router-dom"
import { Box, SxProps, useTheme } from "@mui/material"
import { IExtendedBottomNavigationActionProps } from "components/navigation/type"

interface INavigationLinkProps {
  children: React.ReactNode
  sx?: SxProps
  backSideProps?: Pick<
    IExtendedBottomNavigationActionProps["backSideProps"],
    "children" | "sx"
  >
  onClick?: (event?: any) => void
}

/**
 * NavigationLink is a component for attaching and styling any child component placed behind a menu item via the `backSideProps` prop.
 * The backSide component will be hidden by default.
 */

export const NavigationLink = forwardRef<
  HTMLAnchorElement,
  INavigationLinkProps
>(
  (
    {
      children,
      sx,
      backSideProps,
      onClick = () => {},
      ...props
    }: INavigationLinkProps,
    ref
  ) => {
    const { children: backSideChildren, sx: backSideSx } = backSideProps || {}

    const theme = useTheme()
    const { root, backSide } =
      theme.components[`AppNavigationLink`]?.styleOverrides || {}

    return (
      <BaseLink
        // @ts-ignore
        sx={deepmerge(root, sx)}
        ref={ref}
        onClick={(e) => onClick(e)}
        {...props}
      >
        {children}
        <Box
          className="MuiNavigationLink-backside"
          sx={deepmerge(backSide, backSideSx)}
        >
          {backSideChildren}
        </Box>
      </BaseLink>
    )
  }
)
